"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _reactMotion = require("react-motion");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _modal = _interopRequireDefault(require("./modal"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "diagram-modal__Wrapper",
  componentId: "sc-vuv5ww-0"
})(["position:fixed;left:0;top:0;background-color:", ";z-index:999;"], function (props) {
  return props.ui === "dark" ? (0, _styles.themeTransparentize)(1, "background", props) : (0, _styles.colors)("background", props);
});
var Inner = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "diagram-modal__Inner",
  componentId: "sc-vuv5ww-1"
})(["position:relative;opacity:", ";overflow-y:auto;"], function (props) {
  return props.opacity;
});
var Close = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "diagram-modal__Close",
  componentId: "sc-vuv5ww-2"
})(["position:absolute;top:0;right:20px;"]);
var propTypes = {
  /** children, can be react node */
  children: _propTypes.node,

  /** modal close func handler */
  closeAction: _propTypes.func,

  /** esc handler callback func */
  handleEsc: _propTypes.func,

  /** Root element id for component */
  root: _propTypes.string
};

var DiagramModal = function DiagramModal(_ref) {
  var children = _ref.children,
      closeAction = _ref.closeAction,
      handleEsc = _ref.handleEsc,
      root = _ref.root;
  var onKeyDown = (0, _utils.useEscapeClose)(handleEsc);
  return /*#__PURE__*/_react["default"].createElement(_reactMotion.Motion, {
    defaultStyle: {
      opacity: 0
    },
    style: {
      opacity: (0, _reactMotion.spring)(1, {
        damping: 10,
        stiffness: 60
      })
    }
  }, function (interpolatedStyle) {
    return /*#__PURE__*/_react["default"].createElement(_modal["default"], {
      root: root
    }, /*#__PURE__*/_react["default"].createElement(Wrapper, {
      height: 1,
      onKeyDown: onKeyDown,
      tabIndex: "0",
      width: 1
    }, /*#__PURE__*/_react["default"].createElement(Inner, {
      alignItems: "flex-start",
      height: 1,
      justifyContent: "center",
      opacity: interpolatedStyle.opacity,
      p: 3,
      width: 1
    }, children), /*#__PURE__*/_react["default"].createElement(Close, null, closeAction)));
  });
};

DiagramModal.propTypes = propTypes;
DiagramModal.displayName = "Modules.DiagramModal";

var _default = (0, _styledComponents.withTheme)(DiagramModal);

exports["default"] = _default;